// Central icon map — single source of truth for the app's UI icons.
//
// Lucide (monochrome line icons) instead of emoji: identical on every device,
// follows currentColor, scales crisply. Reference by a stable semantic KEY so
// call sites don't hard-code library names.
//
// NOTE: emoji that are message CONTENT (reminder bodies clients receive) are NOT
// icons and stay as emoji — this map is only for UI chrome.

import {
  Users, UserCog, UserPlus, UserCheck, House, ClipboardList, Bell, Send, Paperclip,
  MessageSquare, Megaphone, RefreshCw, Database, Building2, Shield, ShieldCheck, Mail,
  MailPlus, Settings, Wrench, Handshake, Cake, PartyPopper, Heart, Sparkles, Drumstick,
  TreePine, Copy, Download, Upload, FileUp, FileDown, Eye, Pencil, Globe, Lock, KeyRound,
  Trash2, FlaskConical, Play, Pause, Power, RotateCcw, Search, Plus, X, Check, CircleCheck,
  TriangleAlert, CircleAlert, Info, Clock, Calendar, Moon, Gift, FolderOpen, Archive,
  ArchiveRestore, Filter, Ban, Languages, LogOut, User, Star, MapPin, Phone, AtSign,
  File as FileIcon, FileText, ArrowLeft, ChevronDown, ChevronRight, Square, Repeat,
  Zap, Thermometer, Link2, List,
} from 'lucide-react';

const ICONS = {
  // Agent navigation
  contacts: Users, properties: House, 'reminder-templates': ClipboardList,
  'reminder-assignments': Bell, 'run-reminders': Send, files: Paperclip,
  admin: UserCog, invite: UserPlus, 'message-agents': MessageSquare,
  process: RefreshCw, 'supported-mls': Database,
  // Operator tabs / section labels
  organizations: Building2, 'system-orgs': Shield, message: MessageSquare,
  settings: Settings, mls: Database, reminders: ClipboardList,
  // Brand
  brand: Handshake,
  // Reminder type (built-in card icons)
  'type-new-closing': KeyRound,
  'type-birthday': Cake, 'type-sale-anniversary': House, 'type-new-year': PartyPopper,
  'type-valentines': Heart, 'type-july4': Sparkles, 'type-thanksgiving': Drumstick,
  'type-christmas': TreePine, 'type-custom': ClipboardList,
  // Actions / badges
  copy: Copy, export: Download, import: Upload, upload: Upload, 'file-up': FileUp,
  'file-down': FileDown, view: Eye, rename: Pencil, edit: Pencil, public: Globe,
  private: Lock, lock: Lock, delete: Trash2, test: FlaskConical, launch: Play,
  pause: Pause, power: Power, restore: RotateCcw, search: Search, add: Plus,
  close: X, check: Check, 'check-circle': CircleCheck, warn: TriangleAlert,
  'alert-circle': CircleAlert, info: Info, clock: Clock, calendar: Calendar,
  sleep: Moon, gift: Gift, folder: FolderOpen, archive: Archive,
  unarchive: ArchiveRestore, filter: Filter, ban: Ban, language: Languages,
  logout: LogOut, user: User, star: Star, 'map-pin': MapPin, map: MapPin, list: List, phone: Phone,
  email: AtSign, mail: Mail, 'mail-plus': MailPlus, broadcast: Megaphone,
  'shield-check': ShieldCheck, key: KeyRound, 'user-check': UserCheck,
  // Secondary glyphs (file-type, navigation, status)
  file: FileIcon, 'file-text': FileText, 'arrow-left': ArrowLeft,
  'chevron-down': ChevronDown, 'chevron-right': ChevronRight, stop: Square,
  repeat: Repeat, bulk: Zap, thermometer: Thermometer, link: Link2, wrench: Wrench,
};

// <Icon name="contacts" size={20} /> — inherits color via currentColor.
export default function Icon({ name, size = 20, strokeWidth = 2, className, style, ...rest }) {
  const Cmp = ICONS[name];
  if (!Cmp) return null;
  return <Cmp size={size} strokeWidth={strokeWidth} className={className} style={style} aria-hidden="true" {...rest} />;
}
